// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Migration_ListarRunsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract de GET /migration/franquias/runs
 * (controllers/migration/franquias.php::runs).
 *
 * O historico de execucoes da migracao, mais recente primeiro — a tabela que o
 * operador consulta para saber o que ja rodou, quando, por quem e como
 * terminou. Cada linha e uma execucao (ver `Migration_RunRow`: as de lote tem
 * `zoho_id` nulo, as de uma unidade nao).
 *
 * `dados` e a LISTA direta, sem chave embrulhando, pelo mesmo motivo do
 * preflight: nao ha nenhuma outra informacao a carregar, e um total no wire
 * seria uma segunda opiniao sobre algo derivavel da propria lista.
 *
 * A lista e LIMITADA no model (`listarRecentes`), nao paginada: o historico da
 * migracao e curto por natureza (uma etapa por franquia, uma vez) e uma tela
 * de auditoria que mostra as ultimas execucoes resolve o caso real. Se um dia
 * precisar de paginacao, ela entra aqui como campos novos — nao como uma
 * consulta sem teto agora.
 */
import type { Migration_RunRow } from './Migration_RunRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Migration_ListarRunsResponseDados = Migration_RunRow[];

export type Migration_ListarRunsResponse = ApiResponse<Migration_ListarRunsResponseDados>;

registerResponseContract('Migration_ListarRunsResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      id:          { type: 'number',  required: false },
      etapa:       { type: 'string',  required: false },
      zoho_id:     { type: 'string',  required: false },
      franquia_id: { type: 'number',  required: false },
      status:      { type: 'string',  required: false },
      n_source:    { type: 'number',  required: false },
      n_created:   { type: 'number',  required: false },
      n_skipped:   { type: 'number',  required: false },
      n_failed:    { type: 'number',  required: false },
      n_blocked:   { type: 'number',  required: false },
      started_by:  { type: 'string',  required: false },
      started_at:  { type: 'string',  required: false },
      finished_at: { type: 'string',  required: false },
    },
  },
})
